module.exports = __webpack_public_path__ + "img/logo2.29c417bc.png";